import * as React from "react";
import { useState, useEffect } from "react";
import { useDataProvider, SelectArrayInput } from "react-admin";

export const DepartmentsSelectInput = ({ productionId, ...rest }) => {
    const dataProvider = useDataProvider();
    const [departments, setDepartments] = useState([]);

    useEffect(() => {
        if (!productionId) {
            setDepartments([]);
            return;
        }

        let cancelled = false;

        dataProvider.getOne('productions', { id: productionId })
            .then(({ data }) => {
                if (!cancelled) {
                    setDepartments(data.departments || []);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setDepartments([]);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [dataProvider, productionId]);

    return (
        <SelectArrayInput
            {...rest}
            choices={departments}
            optionText="name"
            optionValue="id"
        />
    );
};